import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import axios from 'axios';
import properties from '../properties';
import { commasForNumbers, numFormatterWithSuffix } from './helper';
import { getXaxisLabels } from './utilizattionProcedureHelper';

export interface TopServiceProviders {
  provider: string;
  claims: string;
  totalCharges: string;
  planPaid: string;
  // paid: string;
  // usage: string;
}

export interface InPatient {
  data: { label: string; value: string | number }[];
  rateOfChange: string | number;
}

export const formatAdmissionsCost = (data: any, selectedFlag: string) => {
  const series: any = [
    {
      seriesname: selectedFlag,
      plottooltext: `Cost - $$dataValue`,
      data: [],
      color: patientAccessTheme.palette.primary[400],
    },
    {
      seriesname: 'Member Count',
      plottooltext: `Members - $dataValue`,
      data: [],
      color: patientAccessTheme.palette.warning[500],
      parentyaxis: 'S',
      renderas: 'line',
      anchorBgColor: patientAccessTheme.palette.warning[500],
    },
  ];

  const xAxis: any = [];

  const dataArray = data?.patient_admissions_summary;

  dataArray?.forEach((item: any) => {
    if (item?.type === selectedFlag) {
      series[0].data.push({ value: item.total_cost });
      series[1].data.push({ value: item.member_count });
      xAxis.push({ label: getXaxisLabels(item.month, item.year) });
    }
  });

  return { series, xAxis };
};

export const getServiceProviders = async (
  requestBody: any,
  setProviders: any,
  setTotalPages: any,
  signal: AbortSignal,
) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.utilizationBaseUrl +
        properties.topServiceProviders,
      requestBody,
      { signal },
    )
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatServiceProviders(
          res?.data?.data?.serviceProviders,
        );
        const totalPages = res?.data?.data?.totalCount;
        setTotalPages(Math.ceil(totalPages / 5));
        setProviders(formattedData);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const formatServiceProviders = (data: any) => {
  const providersDetails: TopServiceProviders[] = [];

  data?.map((item: any) => {
    const eachProvider: TopServiceProviders = {
      provider: '',
      claims: '',
      totalCharges: '',
      planPaid: '',
      // paid: '',
      // usage: '',
    };
    eachProvider.provider = item.providerName;
    eachProvider.claims = item.claims;
    eachProvider.planPaid =
      '$' +
      (item.planPaid > 1000000
        ? numFormatterWithSuffix(item.planPaid, 2)
        : commasForNumbers(item.planPaid));
    // eachProvider.paid = item.paidPercent + '%';
    // eachProvider.usage = item.usagePercent + '%';
    eachProvider.totalCharges =
      '$' +
      (item.totalCharge > 1000000
        ? numFormatterWithSuffix(item.totalCharge, 2)
        : commasForNumbers(item.totalCharge));
    providersDetails.push(eachProvider);
  });

  return providersDetails;
};

export const getInpatientDetails = async (
  requestBody: any,
  setInpatientStay: any,
  type: 'Admissions' | 'In Patinet Days' | 'In patinet Stay',
  signal: AbortSignal,
) => {
  const getUrl = () => {
    switch (type) {
      case 'Admissions':
        return properties.inPatientAdmissions;
      case 'In Patinet Days':
        return properties.inPatientDays;
      case 'In patinet Stay':
        return properties.inPatientAvgStay;
      default:
        return '';
    }
  };
  await axios
    .post(
      properties.aiqBaseUrl + properties.utilizationBaseUrl + getUrl(),
      requestBody,
      { signal },
    )
    .then((res) => {
      if (res?.status === 200) {
        const formattedData = formatInPatient(res?.data?.data, type);
        setInpatientStay(formattedData);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const formatInPatient = (
  data: any,
  type: 'Admissions' | 'In Patinet Days' | 'In patinet Stay',
) => {
  const inPatientAvgStayData: InPatient = {
    data: [
      {
        label: 'Previous',
        value: data.prevYearAvgInpatientStay,
      },
      {
        label: 'Current',
        value: data.currentYearAvgInpatientStay,
      },
    ],
    rateOfChange: data.rateOfChange,
  };
  const inPatientDaysData: InPatient = {
    data: [
      {
        label: 'Previous',
        value: data.prevYearInPatientDays,
      },
      {
        label: 'Current',
        value: data.currentYearInPatientDays,
      },
    ],
    rateOfChange: data.rateOfChange,
  };
  const noOfAdmissionsData: InPatient = {
    data: [
      {
        label: 'Previous',
        value: data.prevYearInPatientAdmits,
      },
      {
        label: 'Current',
        value: data.currentYearInPatientAdmits,
      },
    ],
    rateOfChange: data.rateOfChange,
  };

  switch (type) {
    case 'Admissions':
      return noOfAdmissionsData;
    case 'In Patinet Days':
      return inPatientDaysData;
    case 'In patinet Stay':
      return inPatientAvgStayData;
    default:
      return {};
  }
};

export const formatPlaceOfServiceData = (value: string) => {
  switch (value) {
    case 'In Patient':
      return 'inpatient';
    case 'Emergency':
      return 'emergency';
    case 'Out Patient':
      return 'outpatient';
    case 'Urgent Care':
      return 'urgent care';
    default:
      return '';
  }
};

export const formatProvidersValue = (value: string) => {
  switch (value) {
    case 'In Patient':
      return 'Inpatient';
    case 'Out Patient':
      return 'Outpatient';
    default:
      return value;
  }
};
